import React from 'react'
import cls from 'classnames'
import styled from 'styled-components'

import withValidation from 'components/lib/inputs/withValidation'

const StyledInput = styled.input`
  font-size: 14px;
  width: ${(props) => props.width || '100%'};
  height: 35px;
  border: none;
  border-bottom: 1px solid ${(props) => (props.invalid ? 'var(--red)' : 'var(--primary-color)')};
  border-radius: 0;
  background-color: transparent;
  color: var(--color-text);
  outline: none;

  &::placeholder {
    color: var(--hint-color);
  }

  &.error {
    border-color: var(--red);
  }

  &:disabled {
    opacity: 0.3;
  }
`

function Input({ popup, className, ...rest }) {
  return <StyledInput className={cls('is-input', className)} {...rest} />
}

Input.Field = withValidation(Input)

export default Input
